import React from 'react';
import camelCase from 'lodash/camelCase';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Utils
import { generateHeaderForQuestion } from 'Shared/utils/Reviews.utils';
import { isEmpty } from 'Wpds/components/rich-text/utils/EditorState.utils';

// Components
import { WpRichTextInput } from 'Wpds/components/rich-text';
import { WpBadgeList, WpBadge } from 'Wpds/components/badge';
import PrivateQuestionPopover from './PrivateQuestionPopover';
import QuestionLeftUnanswered from './QuestionLeftUnanswered';

// Styles
import './AdjectivesForPropertyQuestionReview.scss';

type Props = {
  question;
  answers;
  alternateKey?: string;
  slimVersion?: boolean;
};

const AdjectivesForPropertyQuestionReview = ({ question, answers, alternateKey, slimVersion = false }: Props) => {
  const questionKey = ReviewFormTemplatesHelpers.getQuestionKey(question);

  const key = alternateKey || questionKey;

  // the schema normalizer converts all object keys to camel case,
  // including the question keys. if the snake case key doesn't return results
  // check to see if the key is camel case.
  const answersToQuestions = answers[key] || answers[camelCase(key)];
  const adjectives = answersToQuestions?.adjectives;
  const summary = answersToQuestions?.explanation;
  const showBadge = ReviewFormTemplatesHelpers.getQuestionPrivate(question);

  const isAnswerEmpty = (!adjectives || adjectives?.length === 0) && isEmpty(summary);

  const baseClassName = 'AdjectivesForPropertyQuestionReview';
  return (
    <div className={baseClassName}>
      {!slimVersion && (
        <div className={`${baseClassName}__property`}>
          {generateHeaderForQuestion({ question })}
          {showBadge && <PrivateQuestionPopover />}
        </div>
      )}
      {!isAnswerEmpty ? (
        <>
          <div className={`${baseClassName}__badges`}>
            <WpBadgeList>
              {adjectives.map(adjective => (
                <WpBadge size="lg" key={`${key}__${adjective}`}>
                  {adjective}
                </WpBadge>
              ))}
            </WpBadgeList>
          </div>
          <div className={`${baseClassName}__text`}>
            <WpRichTextInput
              value={summary}
              readOnly
              options={{
                showBorder: false,
                transparent: true,
                overflowBehavior: 'grow',
                backgroundColor: 'transparent',
              }}
              height="0"
            />
          </div>
        </>
      ) : (
        <QuestionLeftUnanswered />
      )}
    </div>
  );
};

export default AdjectivesForPropertyQuestionReview;
